module.exports = __webpack_public_path__ + "img/bottom-bg.085c72fb.svg";